import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { Button as AntdButton } from "antd";
import classNames from "classnames";
import { Icon } from "../../../particles/Icon";
import { styleClasses } from "../../../helpers";
import { getRelAttribute, sizeToAntSize, sizeToIconSize, variantToAntType, } from "../helpers";
import "./IconButton.scss";
const CSS_PREFIX = `lav-components-icon-button`;
export const IconButton = forwardRef((_a, ref) => {
    var _b;
    var { state = "initial", size = "medium", variant = "default", icon, className = "" } = _a, antButtonProps = __rest(_a, ["state", "size", "variant", "icon", "className"]);
    const isLoading = state === "loading";
    const [isPressed, setIsPressed] = useState(false);
    useEffect(() => {
        const handleMouseUp = () => setIsPressed(false);
        window.addEventListener("mouseup", handleMouseUp);
        return () => {
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);
    const handleMouseDown = useCallback((e) => {
        setIsPressed(true);
        if (antButtonProps.onMouseDown) {
            antButtonProps.onMouseDown(e);
        }
    }, []);
    return (_jsx(AntdButton, Object.assign({ ref: ref, type: variantToAntType(variant), className: classNames(styleClasses(CSS_PREFIX, {
            size: sizeToAntSize(size),
            state: isPressed ? "pressed" : state,
            variant,
        }), { [className]: !!className }), danger: variant === "danger", disabled: state === "disabled", icon: _jsx(Icon, { size: sizeToIconSize(size), variant: icon }), loading: isLoading, shape: "circle", size: sizeToAntSize(size) }, antButtonProps, { rel: (_b = antButtonProps.rel) !== null && _b !== void 0 ? _b : getRelAttribute(antButtonProps.href, antButtonProps.target), onMouseDown: handleMouseDown })));
});
IconButton.displayName = "IconButton";
